import type { QueryFunctionContext, QueryKey } from "@tanstack/react-query";

/** Return the query's abort signal only once the query holds data. */
export function signalOnceCached<TQueryKey extends QueryKey>(
    context: QueryFunctionContext<TQueryKey>
): AbortSignal | undefined {
    // Never destructure `signal`: reading it lets query-core abort and repeat
    // a cold first read when StrictMode removes and re-adds the observer.
    return context.client.getQueryData(context.queryKey) === undefined
        ? undefined
        : context.signal;
}
